const url = window.location.hostname

/**
 * Get domain type and subtype
 * @returns {{type:string, subtype: string}}
 */
const getAllowedDomains = () => {
  const isLocal = /localhost/.test(url)

  switch (url) {
    // OP-PC
    case 'op-pc.dash.nixi1.com':
    case 'op-pc.dash.dev.v2.nixi1.com':
    case 'op-pc.dash.pre.v2.nixi1.com':
    case 'op-pc.dash.v2.nixi1.com':
    case 'oppc_localhost':
      return {
        isLocal,
        isOP: true,
        type: 'OP',
        subtype: 'OP-PC',
        termsAndConditions: 'https://nixi1.com/general-terms-and-conditions/',
      }
    // // TA
    // case 'ta.dash.dev.nixi1.dkv.es':
    // case 'ta.dash.pre.nixi1.dkv.es':
    // case 'ta.dash.nixi1.dkv.es':
    // case 'ta_localhost':
    //   return {
    //     isLocal,
    //     type: 'TA',
    //     subtype: 'TA',
    //     termsAndConditions: 'https://nixi1.com/general-terms-and-conditions/'
    //   }
    // OP-CC
    case 'op-cc.dash.nixi1.com':
    case 'op-cc.dash.dev.v2.nixi1.com':
    case 'op-cc.dash.pre.v2.nixi1.com':
    case 'op-cc.dash.v2.nixi1.com':
    case 'op.dash.nixi1.com':
    case 'op-dkv-dash.dev.v2.nixi1.dkv.es':
    case 'op-dkv-dash.pre.v2.nixi1.dkv.es':
    case 'op-dkv-dash.v2.nixi1.dkv.es':
    case 'op-dkv-dash.nixi1.dkv.es':
    case 'dkv_localhost':
    case 'opcc_localhost':
    default:
      return {
        isLocal,
        isOP: true,
        type: 'OP',
        subtype: 'OP-CC',
        termsAndConditions: 'https://nixi1.com/general-terms-and-conditions/',
      }
  }
}

export default getAllowedDomains()
